import type {TGetInitialDataResponse} from '@kapitalist/contract/endpoints'
import type {TAuthenticatedPlayerDetails} from '@kapitalist/contract/types'
import {mkPlayerEmail} from '@kapitalist/contract/types'
import gameDataMock from '~/api/endpoints/game/GetGameData/mock'

export const mockPlayerDetails = {
  id: gameDataMock.players[0].playerId,
  username: gameDataMock.players[0].username,
  email: mkPlayerEmail('monroe@ekilah.dev'),
  admin: true,
} satisfies TAuthenticatedPlayerDetails

const globalDataMock: TGetInitialDataResponse = {
  authenticatedPlayerDetails: mockPlayerDetails,
}

export default globalDataMock
